import { apiService } from './api.service';

class NotificationSubscriptionService {
    async getFilters(params = {}) {
        try {
            console.log('Fetching notification filters');
            const response = await apiService.get('/notifications/filters', { params });
            console.log('Filters response:', response);
            return response;
        } catch (error) {
            console.error('Error fetching notification filters:', error);
            throw error;
        }
    }

    async getUserSubscriptions(userId, params = {}) {
        try {
            console.log('Fetching user subscriptions for user:', userId);
            const response = await apiService.get('/notifications/subscriptions', {
                params: { user_id: userId, ...params }
            });
            console.log('Subscriptions response:', response);
            return response;
        } catch (error) {
            console.error('Error fetching user subscriptions:', error);
            throw error;
        }
    }

    async subscribeToFilter(userId, filterId) {
        try {
            // Validate parameters
            if (!userId || !filterId) {
                console.error('Missing required parameters:', { userId, filterId });
                throw new Error('Missing required parameters for subscription');
            }
            
            console.log('Subscribing user to filter:', { userId, filterId });
            const response = await apiService.post(`/notifications/subscriptions/${filterId}`, null, {
                params: { user_id: userId }
            });
            console.log('Subscribe response:', response);
            return response;
        } catch (error) {
            console.error('Error subscribing to filter:', error);
            throw error;
        }
    }

    async unsubscribeFromFilter(userId, filterId) {
        try {
            // Validate parameters
            if (!userId || !filterId) {
                console.error('Missing required parameters:', { userId, filterId });
                throw new Error('Missing required parameters for unsubscription');
            }
            
            console.log('Unsubscribing user from filter:', { userId, filterId });
            const response = await apiService.delete(`/notifications/subscriptions/${filterId}`, {
                params: { user_id: userId }
            });
            console.log('Unsubscribe response:', response);
            return response;
        } catch (error) {
            console.error('Error unsubscribing from filter:', error);
            throw error;
        }
    }
}

export default new NotificationSubscriptionService(); 